import { RightOutlined } from '@ant-design/icons';
import { List } from 'antd';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { type PageTypes } from '.';
import { MenuList, ListItem } from './styled';

let isUserVerifyingPlatformAuthenticatorAvailable = false;

type UserSelfMenuItem = {
    label: string;
    key: PageTypes;
};

type UserSelfMenuItemsProps = {
    onMenuItemClicked: (pageType: PageTypes) => void;
};

const UserSelfMenuItems = ({ onMenuItemClicked }: UserSelfMenuItemsProps) => {
    const { t } = useTranslation('userSelf');

    const [mayWebAuthn, setMayWebAuthn] = useState(isUserVerifyingPlatformAuthenticatorAvailable);

    useEffect(() => {
        if (PublicKeyCredential) {
            PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable().then(result => {
                isUserVerifyingPlatformAuthenticatorAvailable = result;
                setMayWebAuthn(result);
            });
        }
    }, [setMayWebAuthn]);

    const items: UserSelfMenuItem[] = [
        {
            label: t('userSelf:authenticatorSettings.title'),
            key: 'authenticator2FA',
        },
        {
            label: t('userSelf:passwordSettings.title'),
            key: 'changePassword',
        },
        {
            label: t('userSelf:sessions.title'),
            key: 'activeSessions',
        },
    ];

    if (mayWebAuthn) {
        items.splice(2, 0, {
            label: t('userSelf:webAuthnSettings.title'),
            key: 'webAuthnSettings',
        });
    }

    return (
        <MenuList
            dataSource={items}
            renderItem={(item: UserSelfMenuItem) => (
                <ListItem
                    key={item.key}
                    onClick={() => {
                        onMenuItemClicked(item.key);
                    }}
                >
                    <List.Item.Meta title={item.label} />
                    <RightOutlined />
                </ListItem>
            )}
        />
    );
};
export default UserSelfMenuItems;
